import React, { Component } from "react";
import i18n from "../i18n";
import * as rk from "../localization/resourceKeys";

export default class MaintenanceComp extends Component {
  render() {
    return (
      <div className="o-layout">
        <p className="o-layout__item u-8/12 u-text-center u-font-size-fs-1 u-block u-block-center">{i18n.t(rk.MAINTENANCE_CONTENT)}</p>
      </div>
    );
  }
}
